export var RADIO_BUTTON_SHAPES = {
  squared: 'squared',
  pill: 'pill'
};